module.exports = __webpack_public_path__ + "static/media/build.c90fc51f.png";